import { localDay } from "@/lib/studio";

export const dailyTotals = (hours) => {
  const days = {};
  (hours || []).forEach((h) => { const k = localDay(new Date(`${h.hour}:00:00Z`)); days[k] = (days[k] || 0) + h.words; });
  return days;
};

export const computeStreak = (hours, goal) => {
  if (!goal) return 0;
  const days = dailyTotals(hours);
  const d = new Date();
  if ((days[localDay(d)] || 0) < goal) d.setDate(d.getDate() - 1);
  let n = 0;
  while ((days[localDay(d)] || 0) >= goal) { n += 1; d.setDate(d.getDate() - 1); }
  return n;
};

export const streakParams = () => {
  const s = new Date();
  s.setDate(s.getDate() - 400);
  return { start: s.toISOString().slice(0, 13), end: new Date().toISOString().slice(0, 13) };
};

const COLORS = ["#F59E0B", "#FBBF24", "#10B981", "#C4B5FD", "#F87171", "#F3EBDD"];

export const Confetti = () => (
  <div className="pointer-events-none fixed inset-0 z-[100] overflow-hidden" data-testid="goal-confetti">
    {Array.from({ length: 70 }, (_, i) => (
      <span key={i} className="lf-confetti" style={{ left: `${(i * 37) % 100}%`, background: COLORS[i % COLORS.length], animationDelay: `${(i % 10) * 0.07}s`, animationDuration: `${1.8 + (i % 5) * 0.3}s`, transform: `rotate(${i * 29}deg)` }} />
    ))}
  </div>
);
